import Utils from 'utilities/helper.util';
import _ from 'lodash';

export const calculateDayLeft = (autoRenew: any) => {
  const todaysDate = Utils.getNewDate().startOf('day');
  const renewUntil = Utils.getNewDate(autoRenew.auto_renew_until).startOf(
    'day'
  );
  let nextRenewal = Utils.getNewDate(autoRenew.auto_renew_date);
  if (!autoRenew.internal_create) {
    while (todaysDate.isAfter(nextRenewal) && nextRenewal <= renewUntil) {
      nextRenewal = nextRenewal.clone().add(28, 'day');
    }
  }
  const daysLeft = nextRenewal.diff(todaysDate.format(), 'days');
  const diff = renewUntil.diff(nextRenewal, 'days');

  if (diff < 0) {
    return '-';
  }

  let display = `${daysLeft} days`;

  if (Math.sign(daysLeft) === -1) {
    display = '-';
  } else if (daysLeft === 0) {
    display = 'today';
  } else if (daysLeft === 1) {
    display = '1 day';
  }
  if (_.isNaN(daysLeft)) {
    display = '-';
  }

  return display;
};

export const calculateRenewalsLeft = (autoRenew: any) => {
  const todaysDate = Utils.getNewDate().startOf('day');
  let nextRenewal = Utils.getNewDate(autoRenew.auto_renew_date).startOf('day');
  const renewUntil = Utils.getNewDate(autoRenew.auto_renew_until).startOf(
    'day'
  );
  const intervals = autoRenew.internal_create
    ? 28 - autoRenew.auto_renew_every
    : 28;
  let total = 0;

  if (!autoRenew.internal_create) {
    while (todaysDate.isAfter(nextRenewal) && nextRenewal <= renewUntil) {
      nextRenewal = nextRenewal.clone().add(28, 'day');
    }
  }

  while (renewUntil.diff(nextRenewal) >= 0) {
    total++;
    nextRenewal = nextRenewal.clone().add(intervals, 'day');
  }

  return total;
};

export const calculateNextRenewal = (autoRenew: any, renewalsLeft: number) => {
  const todaysDate = Utils.getNewDate().startOf('day');
  let nextRenewal = Utils.getNewDate(autoRenew.auto_renew_date).startOf('day');
  const renewUntil = Utils.getNewDate(autoRenew.auto_renew_until).startOf(
    'day'
  );
  if (!autoRenew.internal_create) {
    while (todaysDate.isAfter(nextRenewal) && nextRenewal <= renewUntil) {
      nextRenewal = nextRenewal.clone().add(28, 'day');
    }
  }
  const nextRenewalDate =
    renewalsLeft > 0 ? nextRenewal.format('DD MMM YYYY') : '-';
  return nextRenewalDate;
};
